import {
  IPE_UI_LOCALE_EVENT,
  IPE_UI_LOCALE_STORAGE_KEY,
  normalizeIpeUiLocale,
} from './locales';

export function getIpeUiLocale() {
  try {
    return normalizeIpeUiLocale(window.localStorage.getItem(IPE_UI_LOCALE_STORAGE_KEY));
  } catch {
    return 'zh-CN';
  }
}

export function setIpeUiLocale(next) {
  const locale = normalizeIpeUiLocale(next);
  try {
    window.localStorage.setItem(IPE_UI_LOCALE_STORAGE_KEY, locale);
  } catch {
    /* 隐私模式写失败时仍切换当前页 */
  }
  window.dispatchEvent(new CustomEvent(IPE_UI_LOCALE_EVENT, { detail: { locale } }));
  return locale;
}
